var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Name", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Name" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Message", prop: "message" } },
            [
              _c("el-input", {
                ref: "message",
                staticClass: "message-input",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 8 },
                  placeholder: "Message",
                },
                model: {
                  value: _vm.form.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "message", $$v)
                  },
                  expression: "form.message",
                },
              }),
              _vm._v(" "),
              _c("message-tools", {
                on: { "insert-value": _vm.insertValueIntoMessage },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { prop: "min_interval" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content:
                              "Minimal interval since the last contact in days",
                            placement: "top-start",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v("Minimal Interval "),
                            _c("i", { staticClass: "far fa-question-circle" }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("min-interval-select", {
                staticClass: "w-100",
                attrs: { placeholder: "Time since last contact" },
                model: {
                  value: _vm.form.min_interval,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "min_interval", $$v)
                  },
                  expression: "form.min_interval",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { prop: "max_messages" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content: "Send Messages Limit",
                            placement: "top-start",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v("Send Limit "),
                            _c("i", { staticClass: "far fa-question-circle" }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "Send Messages Limit" },
                model: {
                  value: _vm.form.max_messages,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "max_messages", $$v)
                  },
                  expression: "form.max_messages",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-create px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }